var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGroupChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 250.582,
    x2: 384.007,
    xlinkHref: "#lg1",
    y1: 420.186,
    y2: 500.862
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f89580"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.814,
    x2: 313.814,
    xlinkHref: "#lg2",
    y1: 504.784,
    y2: 439.294
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 340.105,
    x2: 439.789,
    xlinkHref: "#lg1",
    y1: 293.773,
    y2: 354.047
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 465.851,
    x2: 436.484,
    xlinkHref: "#lg2",
    y1: 358.799,
    y2: 358.799
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.299,
    x2: 440.798,
    xlinkHref: "#lg3",
    y1: 104.764,
    y2: 402.263
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 425.282,
    x2: 0.311,
    xlinkHref: "#lg3",
    y1: 386.747,
    y2: -38.224
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.219,
    x2: 329.409,
    y1: 122.684,
    y2: 290.874
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3e5959",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.808,
    x2: 337.808,
    xlinkHref: "#lg4",
    y1: 126.667,
    y2: 4.335
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.208,
    x2: 300.208,
    xlinkHref: "#lg4",
    y1: 294.901,
    y2: 87.901
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 376.787,
    x2: 337.787,
    xlinkHref: "#lg4",
    y1: 188.37,
    y2: 42.37
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.398,
    x2: 334.398,
    xlinkHref: "#lg4",
    y1: 438,
    y2: 354.164
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef5f6"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 330.903,
    x2: 330.903,
    xlinkHref: "#lg5",
    y1: 68.667,
    y2: 90.168
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 321.517,
    x2: 321.517,
    xlinkHref: "#lg5",
    y1: 211.667,
    y2: 233.168
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientTransform: "matrix(-1 0 0 1 460.667 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 248.431,
    x2: 248.431,
    xlinkHref: "#lg6",
    y1: 158,
    y2: 179.501
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientTransform: "matrix(-1 0 0 1 460.667 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 266.711,
    x2: 266.711,
    xlinkHref: "#lg6",
    y1: 263.5,
    y2: 285.001
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientTransform: "matrix(-1 0 0 1 460.667 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 253.461,
    x2: 253.461,
    xlinkHref: "#lg6",
    y1: 325.5,
    y2: 347.001
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.017,
    x2: 358.017,
    xlinkHref: "#lg5",
    y1: 126.667,
    y2: 148.168
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.517,
    x2: 327.517,
    xlinkHref: "#lg5",
    y1: 369.333,
    y2: 390.835
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.506,
    x2: 271.506,
    xlinkHref: "#lg4",
    y1: 418.43,
    y2: 468.272
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 400.888,
    x2: 400.888,
    xlinkHref: "#lg4",
    y1: 327.246,
    y2: 262.312
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.274,
    x2: 413.208,
    xlinkHref: "#lg4",
    y1: 218.129,
    y2: 179.064
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 381.334,
    x2: 481.018,
    xlinkHref: "#lg1",
    y1: 225.586,
    y2: 285.86
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 313.814,
    x2: 313.814,
    xlinkHref: "#lg2",
    y1: 485.659,
    y2: 504.784
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 237.949,
    x2: 49.542,
    xlinkHref: "#lg4",
    y1: 200.621,
    y2: 12.214
  })), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.413,
    x2: 145.46,
    xlinkHref: "#lg6",
    y1: 55.192,
    y2: 204.332
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.831,
    x2: 66.331,
    xlinkHref: "#lg4",
    y1: 355.089,
    y2: 261.089
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 96.825,
    x2: 134.159,
    y1: 257.171,
    y2: 365.171
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientTransform: "matrix(-1 0 0 1 746.313 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 304.878,
    x2: 352.63,
    y1: 354.852,
    y2: 492.992
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.933,
    x2: 443.933,
    y1: 95,
    y2: 170.06
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m398.429 510h-169.231c-13.764 0-24.921-11.158-24.921-24.921v-53.319c0-13.764 11.158-24.921 24.921-24.921h169.231c13.764 0 24.921 11.158 24.921 24.921v53.319c0 13.763-11.157 24.921-24.921 24.921z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.277 451.465v14.199l44.336 44.336h149.816c13.764 0 24.921-11.158 24.921-24.921v-33.614z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.76 250.358v114.025c0 45.853-37.171 83.025-83.025 83.025v-197.05z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.714 279.336h-8.114v158.927c26.807-13.767 45.16-41.671 45.16-73.88v-48.001z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m407.102 465.942h-271.192c-15.851 0-28.701-12.85-28.701-28.701v-408.54c0-15.851 12.85-28.701 28.701-28.701h271.192c15.851 0 28.701 12.85 28.701 28.701v408.541c0 15.85-12.85 28.7-28.701 28.7z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m396.594 452.044h-250.177c-14.777 0-26.756-11.979-26.756-26.756v-384.634c0-14.777 11.979-26.756 26.756-26.756h250.177c14.777 0 26.756 11.979 26.756 26.756v384.635c0 14.776-11.979 26.755-26.756 26.755z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m385.466 27.807h-67.016c-2.027 0-3.671 1.643-3.671 3.671 0 5.655-4.584 10.239-10.239 10.239h-66.07c-5.655 0-10.239-4.584-10.239-10.239 0-2.027-1.643-3.671-3.671-3.671h-67.016c-13.668 0-24.747 11.08-24.747 24.747v360.833c0 13.668 11.08 24.747 24.747 24.747h227.921c13.668 0 24.747-11.08 24.747-24.747v-360.833c.002-13.667-11.078-24.747-24.746-24.747z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m410.214 81.948-13.231-13.231c-2.562-3.812-6.914-6.322-11.852-6.322h-105.456c-7.882 0-14.272 6.39-14.272 14.272v11.893c0 4.939 2.509 9.29 6.322 11.853l138.489 138.489z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.213 224.95v176.28l-157.81-157.82c-3.81-2.56-6.32-6.91-6.32-11.85v-11.89c0-7.88 6.39-14.27 14.27-14.27h124.78c4.94 0 9.29 2.5 11.85 6.32z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.213 139.61v102.78l-84.31-84.31c-3.81-2.56-6.32-6.91-6.32-11.85v-11.9c0-7.88 6.39-14.27 14.27-14.27h51.28c4.94 0 9.29 2.51 11.85 6.32z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m354.633 362.56h-51.28c-7.88 0-14.27 6.39-14.27 14.27v11.9c0 4.94 2.51 9.29 6.32 11.85l37.555 37.555h22.009c13.657 0 24.729-11.063 24.747-24.716v-31.309l-13.23-13.23c-2.561-3.81-6.911-6.32-11.851-6.32z",
    fill: "url(#SVGID_11_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m383.631 60.895h-105.456c-7.882 0-14.272 6.39-14.272 14.272v11.893c0 7.882 6.39 14.272 14.272 14.272h77.713l22.118 11.089c3.741 1.858 8.048-1.19 7.538-5.337l-.715-5.813c7.32-.61 13.074-6.734 13.074-14.212v-11.891c0-7.883-6.39-14.273-14.272-14.273z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.631 203.895h-124.228c-7.882 0-14.272 6.39-14.272 14.272v11.893c0 7.882 6.39 14.272 14.272 14.272h96.485l22.118 11.089c3.741 1.858 8.048-1.19 7.538-5.337l-.715-5.813c7.32-.61 13.074-6.734 13.074-14.212v-11.893c0-7.881-6.39-14.271-14.272-14.271z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.508 150.229h105.456c7.882 0 14.272 6.39 14.272 14.272v11.893c0 7.882-6.39 14.272-14.272 14.272h-77.713l-22.118 11.089c-3.741 1.858-8.048-1.19-7.538-5.337l.715-5.813c-7.32-.61-13.074-6.734-13.074-14.212v-11.893c0-7.881 6.39-14.271 14.272-14.271z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.508 255.729h68.894c7.882 0 14.272 6.39 14.272 14.272v11.893c0 7.882-6.39 14.272-14.272 14.272h-41.152l-22.118 11.089c-3.741 1.858-8.048-1.19-7.538-5.337l.715-5.813c-7.32-.61-13.074-6.734-13.074-14.212v-11.893c.001-7.881 6.391-14.271 14.273-14.271z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m159.508 317.729h95.394c7.882 0 14.272 6.39 14.272 14.272v11.893c0 7.882-6.39 14.272-14.272 14.272h-67.652l-22.118 11.089c-3.741 1.858-8.048-1.19-7.538-5.337l.715-5.813c-7.32-.61-13.074-6.734-13.074-14.212v-11.893c.001-7.881 6.391-14.271 14.273-14.271z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m383.631 118.895h-51.228c-7.882 0-14.272 6.39-14.272 14.272v11.893c0 7.882 6.39 14.272 14.272 14.272h23.485l22.118 11.089c3.741 1.858 8.048-1.19 7.538-5.337l-.715-5.813c7.32-.61 13.074-6.734 13.074-14.212v-11.893c0-7.881-6.39-14.271-14.272-14.271z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.131 361.562h-51.228c-7.882 0-14.272 6.39-14.272 14.272v11.893c0 7.882 6.39 14.272 14.272 14.272h23.485l22.118 11.089c3.741 1.858 8.048-1.19 7.538-5.337l-.715-5.813c7.32-.61 13.074-6.734 13.074-14.212v-11.893c0-7.881-6.39-14.271-14.272-14.271z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m107.209 390.611v46.63c0 15.851 12.85 28.701 28.701 28.701h271.192c15.851 0 28.701-12.85 28.701-28.701v-46.63z",
    fill: "url(#SVGID_19_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m435.803 339.505v-69.829h-69.829z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.802 177.125h-35.066v14l35.066 35.066z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m472.76 279.336h-79.718c-23.353 0-42.285-18.932-42.285-42.285v-.693c0-15.314 12.414-27.728 27.728-27.728h51.99c23.353 0 42.285 18.932 42.285 42.285z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.277 472.329v12.75c0 13.764 11.157 24.921 24.921 24.921h169.231c13.764 0 24.921-11.158 24.921-24.921v-12.75z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m173.273 34.76v.009l-.002-.007h-66.062l.004 136.298 244.661 244.672v-202.37z",
    fill: "url(#SVGID_24_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m119.746 13.898h-40.237c-43.334 0-78.463 35.129-78.463 78.463 0 43.334 35.129 78.463 78.463 78.463h40.238c4.563 0 9.028-.411 13.377-1.159l23.694 11.77c5.891 2.926 12.671-1.874 11.868-8.402l-2.173-17.669c19.233-14.3 31.696-37.194 31.696-63.002.001-43.335-35.129-78.464-78.463-78.464z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m155.555 66.633h-111.855c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h111.855c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.52-2.854 6.375-6.375 6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m155.555 102.565h-111.855c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h111.855c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.521-2.854 6.375-6.375 6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m98.758 138.498h-55.058c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h55.058c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.521-2.854 6.375-6.375 6.375z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m381.373 465.942-226.759-226.703c.001-.018.001-.037.003-.055-.323-3.68-4.314-6.123-7.837-4.373l-15.628 7.763c-2.869-.493-5.814-.764-8.823-.764h-15.12v102.504l121.629 121.629h152.535z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m122.329 344.313h-26.54c-28.582 0-51.752-23.17-51.752-51.752 0-28.582 23.17-51.752 51.752-51.752h26.54c3.01 0 5.954.271 8.823.765l15.628-7.763c3.885-1.93 8.357 1.236 7.828 5.542l-1.433 11.654c12.685 9.432 20.906 24.532 20.906 41.554 0 28.581-23.17 51.752-51.752 51.752z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m139.654 284.565h-61.19c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h61.19c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.521-2.854 6.375-6.375 6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m122.516 320.498h-44.052c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h44.051c3.521 0 6.375 2.854 6.375 6.375v8.693c.001 3.521-2.853 6.375-6.374 6.375z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.814 466.313h33.946c36.558 0 66.195-29.636 66.195-66.195 0-36.558-29.636-66.195-66.195-66.195h-33.946c-3.85 0-7.616.347-11.286.978l-19.99-9.93c-4.97-2.469-10.69 1.581-10.013 7.089l1.833 14.907c-16.225 12.064-26.74 31.379-26.74 53.151.001 36.558 29.637 66.195 66.196 66.195z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m464.92 389.891h-78.266c-4.503 0-8.154-3.651-8.154-8.154v-11.119c0-4.504 3.651-8.154 8.154-8.154h78.266c4.503 0 8.154 3.651 8.154 8.154v11.119c0 4.504-3.651 8.154-8.154 8.154z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m442.999 435.852h-56.345c-4.503 0-8.154-3.651-8.154-8.154v-11.119c0-4.503 3.651-8.154 8.154-8.154h56.345c4.503 0 8.154 3.651 8.154 8.154v11.119c0 4.503-3.651 8.154-8.154 8.154z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.663 81.117h26.54c28.582 0 51.752 23.17 51.752 51.752 0 28.582-23.17 51.752-51.752 51.752h-26.54c-3.01 0-5.954-.271-8.823-.765l-15.628 7.763c-3.885 1.93-8.357-1.236-7.828-5.542l1.433-11.654c-12.685-9.432-20.906-24.532-20.906-41.554 0-28.582 23.17-51.752 51.752-51.752z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3e5959"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m474.528 126.375h-61.19c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h61.19c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.521-2.854 6.375-6.375 6.375z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m457.39 162.308h-44.051c-3.521 0-6.375-2.854-6.375-6.375v-8.693c0-3.521 2.854-6.375 6.375-6.375h44.051c3.521 0 6.375 2.854 6.375 6.375v8.693c0 3.521-2.855 6.375-6.375 6.375z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroupChat);
export default __webpack_public_path__ + "static/media/icon-group-chat.ea8dd09182e47580db3d2ee23736c7e1.svg";
export { ForwardRef as ReactComponent };